
import * as CONST from 'common/const';
import createReducer from './createReducer';

const initialState = {
  loading: false,
  iCData: {},
  error: '',
  initialized: {}
}

export default createReducer(initialState, {
  [CONST.FETCH_ICDATA_REQUEST]: state => ({
    ...state,
    loading: true,
    error: ''
  }),

  [CONST.FETCH_ICDATA_SUCCESS]: (state, action) => {
    const newICData = {...state.iCData};
    newICData[action.id] = action.iCDataList;
    const newInitialized = {...state.initialized};
    newInitialized[action.id] = true;
    return {
      ...state,
      loading: false,
      error: '',
      iCData: newICData,
      initialized: newInitialized
    };
  },

  [CONST.FETCH_ICDATA_FAILURE]: (state, action) => {
    const newICData = {...state.iCData};
    newICData[action.id] = [];
    const newInitialized = {...state.initialized};
    newInitialized[action.id] = true;
    return {
      ...state,
      loading: false,
      error: action.payload,
      initialized: newInitialized,
      iCData: newICData
    };
  },
});
